// Loads the ONLYOFFICE DocsAPI script exactly once.
let loadPromise: Promise<void> | null = null;

export function loadDocsApi(serverUrl: string): Promise<void> {
  if ((window as any).DocsAPI) return Promise.resolve();
  if (loadPromise) return loadPromise;

  loadPromise = new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');
    script.src = `${serverUrl.replace(/\/$/, '')}/web-apps/apps/api/documents/api.js`;
    script.async = true;
    script.onload = () => {
      if ((window as any).DocsAPI) resolve();
      else reject(new Error('DocsAPI failed to initialize'));
    };
    script.onerror = () => {
      loadPromise = null;
      reject(new Error('Failed to load ONLYOFFICE DocsAPI script'));
    };
    document.body.appendChild(script);
  });
  return loadPromise;
}
